module.exports = __webpack_public_path__ + "img/17.040ca748.jpg";